import Checkbox, { CheckboxProps } from 'antd/lib/checkbox';

interface Props extends CheckboxProps {
    qa?: string;
}

export default function EnhancedCheckbox({ qa, ...props }: Props) {
    return <Checkbox data-qa={qa} {...props} />;
}
